import gql from 'graphql-tag';

export default gql`
    mutation hydrationDayChangeGoal($date: Date!, $goal: Int!, $unit: String!) {
        me {
            hydrationDayChangeGoal(date: $date, goal: $goal, unit: $unit) {
                __typename
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on UserHydrationDay {
                    key
                    goal {
                        value
                        unit
                    }
                    portions {
                        id
                        value {
                            value
                            unit
                        }
                    }
                }
            }
        }
    }
`;
